<template>
  <v-dialog
    v-model="changeCalledByDialog"
    persistent
    scrollable
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        @click="changeCalledByDialogInit"
      >
        <v-icon>
          mdi-account-switch-outline
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogCalledBy.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />
        <v-container
          v-if="loaded && changeCalledByModel"
          fluid
        >
          <v-row>
            <v-col>
              <div>
                {{ $t('supportTicketDialogCalledBy.current') }}
              </div>
              <strong>
                {{ changeCalledByModel.data.currentCalledBy }}
              </strong>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="changeCalledByModel.data.newCalledById"
                :items="changeCalledByModel.metadata.calledBys"
                item-text="text"
                item-value="value"
                :label="$t('supportTicketDialogCalledBy.calledByLabel')"
                outlined
                dense
                @change="hasChanged = true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="changeCalledByModel.data.comment"
                :label="$t('supportTicketDialogCalledBy.commentLabel')"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions v-if="loaded">
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="changeCalledByDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!hasChanged"
          @click="changeCalledByDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: "SupportTicketDialogCalledBy",
  components: {
    Loading
  },
  props: {},
  data() {
    return {
      changeCalledByModel: Object,
      changeCalledByDialog: false,
      hasChanged: false,
      loaded: false,
      saving: false
    };
  },
  methods: {
    changeCalledByDialogInit: function ()  {
      this.$api.get(`supportticket/changeCalledBy/${this.$route.params.id}`).then((response) => {
        this.changeCalledByModel = response.data;
        this.changeCalledByDialog = true;
        this.loaded = true;
      });
    },
    changeCalledByDialogSave: function () {
      this.saving = true;

      this.$api.put(`supportticket/changeCalledBy/${this.$route.params.id}`, this.changeCalledByModel.data).then((response) => {
        if (response.data.success) {
          this.saving = false;
          this.changeCalledByDialog = false;
          this.hasChanged = false;
          this.$emit("saved");
        } else {
          //TODO: Error handle...
        }
      });
    },
    changeCalledByDialogCancel: function () {
      // Reset to initial values
      this.changeCalledByModel = null;
      this.changeCalledByDialog = false;
      this.hasChanged = false;
      this.loaded = false;
    },
  },
};
</script>